import script from "./MindTree.vue?vue&type=script&setup=true&lang=js"
export * from "./MindTree.vue?vue&type=script&setup=true&lang=js"

import "./MindTree.vue?vue&type=style&index=0&id=afe529f0&lang=css"

const __exports__ = script;

export default __exports__